import React from "react";
import Icon from "../ui/Icon";
import ProjectArt from "../visuals/ProjectArt";
import { domains, statusTone } from "./Data";

const domainLabel = Object.fromEntries(domains.map((d) => [d.id, d.label]));

const WorkItems = ({ project, fig, onOpen }) => {
  const { title, tagline, stack, status, domain, repo, links = [], featured } = project;
  const headingId = `card-${project.slug}`;

  // Pointer-follow glow: write the cursor position to CSS variables (no re-render).
  const onPointerMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - rect.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - rect.top}px`);
    // gentle tilt toward the pointer (max about 2.5deg), only for fine pointers
    if (e.pointerType === "mouse") {
      const nx = (e.clientX - rect.left) / rect.width - 0.5;
      const ny = (e.clientY - rect.top) / rect.height - 0.5;
      e.currentTarget.style.setProperty("--ry", `${(nx * 5).toFixed(2)}deg`);
      e.currentTarget.style.setProperty("--rx", `${(-ny * 5).toFixed(2)}deg`);
    }
  };

  const onPointerLeave = (e) => {
    e.currentTarget.style.setProperty("--rx", "0deg");
    e.currentTarget.style.setProperty("--ry", "0deg");
  };

  return (
    <article
      className="card"
      aria-labelledby={headingId}
      data-featured={featured || undefined}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
    >
      <div className="frame" aria-hidden="true">
        <div className="frame__bar">
          <span>FIG. {String(fig).padStart(2, "0")}</span>
          <span>{project.repoName ?? project.slug}</span>
        </div>
        <div className="frame__body">
          <ProjectArt slug={project.slug} />
        </div>
      </div>

      <div className="card__meta">
        <span className="card__domain">{domainLabel[domain]}</span>
        <span className={`badge badge--${statusTone[status]}`}>{status}</span>
      </div>

      <h3 id={headingId} className="card__title">
        {title}
      </h3>
      <p className="card__tagline">{tagline}</p>

      <ul className="card__stack" aria-label="Stack">
        {stack.map((s) => (
          <li key={s} className="tag">
            {s}
          </li>
        ))}
      </ul>

      <div className="card__actions">
        <button type="button" className="btn btn--sm btn--primary" onClick={onOpen}>
          Case file <Icon name="arrow" />
          <span className="sr-only"> for {title}</span>
        </button>
        <a className="btn btn--sm" href={repo} target="_blank" rel="noreferrer">
          <Icon name="github" /> Repo
          <span className="sr-only"> for {title} (opens in a new tab)</span>
        </a>
        {links.map((l) => (
          <a key={l.url} className="btn btn--sm" href={l.url} target="_blank" rel="noreferrer">
            {l.label} <Icon name="external" />
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
        ))}
      </div>
    </article>
  );
};

export default WorkItems;
